/**
 * Check if an API response is a paywall error and show the modal.
 * Use this in existing fetch calls without needing to refactor them.
 *
 * Usage:
 *   const { showPaywall } = usePaywall();
 *   const res = await fetch(url, opts);
 *   if (handlePaywallResponse(res, showPaywall)) return; // paywall was shown
 */
export async function handlePaywallResponse(response, showPaywall) {
  if (!response || (response.status !== 402 && response.status !== 403)) return false;
  
  try {
    const cloned = response.clone();
    const data = await cloned.json();
    if (data.detail && typeof data.detail === "object" && data.detail.paywall) {
      showPaywall(data.detail);
      return true;
    }
  } catch {
    // Not JSON or not a paywall response
  }
  return false;
}
